import { enhancedApi } from '@store/generated/payers';

/**
 * Feature-specific tag types for payer cache management
 */
const PAYER_TAG_TYPES = ['Payer', 'PayerList'] as const;

/**
 * Payer Search API - extends the generated OpenAPI client
 * This ensures we're using generated types and endpoints
 * while maintaining feature-specific customization
 */
export const payerSearchApi = enhancedApi.enhanceEndpoints({
  addTagTypes: PAYER_TAG_TYPES,
  endpoints: {
    getV2AdminPayers: {
      providesTags: result =>
        result
          ? [
              ...result.items.map(({ id }) => ({
                type: 'Payer' as const,
                id: id || 'unknown',
              })),
              { type: 'PayerList' as const, id: 'ADMIN_LIST' },
            ]
          : [{ type: 'PayerList', id: 'ADMIN_LIST' }],
    },
    // Enhance generated endpoints with cache tags
    getV2ProviderPayers: {
      providesTags: result =>
        result
          ? [
              ...result.items.map(({ id }) => ({
                type: 'Payer' as const,
                id: id || 'unknown',
              })),
              { type: 'PayerList' as const, id: 'LIST' },
            ]
          : [{ type: 'PayerList', id: 'LIST' }],
    },

    getV2ProviderPayersByPayerId: {
      providesTags: (_result, _error, arg) => [{ type: 'Payer', id: arg.payerId }],
    },
  },
});

// Export hooks with user-friendly names only
export const {
  useGetV2AdminPayersQuery: useGetAdminPayersQuery,
  useGetV2ProviderPayersQuery: useGetPayersQuery,
  useLazyGetV2ProviderPayersQuery: useLazyGetPayersQuery,
  useGetV2ProviderPayersByPayerIdQuery: useGetPayerByIdQuery,
  useLazyGetV2ProviderPayersByPayerIdQuery: useLazyGetPayerByIdQuery,
} = payerSearchApi;
